const FacebookFeed = () => {
  return (
    <div id="facebook">
      <h2 className="brand-images__title">
        Τελευταίες αναρτήσεις στο Facebook
      </h2>
      <div className="powr-facebook-feed " id="bb20692a_1662403651"></div>
    </div>
  );
};

export default FacebookFeed;
